import { controller_card } from '@lc//controller/card';
import { act_com } from '@lc/action/cardType/Common';
import { tieBreaker } from '@lc/const/modifiers';
import { GameState } from '@lc/interface/gameState/types';
import { act_player } from '@lc/interface/player/action';
import { Player } from '@lc/interface/player/types';
import { getRandomArrayIndex } from '@lc/lib/array';
import {
	getPlayerIdFromArrayIndex,
	getPlayerStateWithId,
} from '@lc/lib/player_helper';

/*
    Return id of player who won award so it can be added into their completed pile
    OR
    Return -1 if no player won Award
*/
class AwardAction {
	targetPlayer = [
		{
			playerId: 1,
			numCarbon: 1,
		},
	];

	getWinnerId = (arr: number[]) => {
		if (arr && arr.length === 1) {
			return arr[0];
		}

		return -1;
	};

	getWinnerIdFromArrayIndex = (playerStateArray: Player[], arr: number[]) => {
		if (arr && arr.length === 1) {
			return getPlayerIdFromArrayIndex(playerStateArray, arr[0]);
		} else if (arr.length > 1) {
			// tiebreaker modifier check
			for (let i = 0; i < arr.length; i++) {
				const currPlayerId = getPlayerIdFromArrayIndex(
					playerStateArray,
					i
				);
				const pState = getPlayerStateWithId(
					playerStateArray,
					currPlayerId
				);
				if (pState.modifiers.includes(tieBreaker)) {
					return currPlayerId;
				}
			}
		}

		return -1;
	};

	resolveAwardDonation(awardIds: any, players: any, donoCounter: number) {
		console.log('resolveAwardDonation');
		if (awardIds.length !== 1 || donoCounter <= 0) {
			return -1;
		}
		console.log('awardIds');
		console.log(awardIds);

		console.log('players');
		console.log(players);

		const p = players[awardIds[0]];

		console.log('p');
		console.log(p);

		console.log('donoCounter');
		console.log(donoCounter);

		while (donoCounter > 0) {
			p.donationCupArr.push(p.energyColor);
			donoCounter--;
		}

		return awardIds[0];
	}

	americaPower(
		playerData: any,
		gameState: GameState,
		prize: boolean = false
	) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		let highestIds: number[] = [];
		let highestPR = 0;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const currPR = players[currId].prArr.length;
			if (currPR > highestPR) {
				highestPR = currPR;
				highestIds = [currId];
			} else if (currPR === highestPR) highestIds.push(currId);
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, highestIds);

		if (prize) {
			return act_com.rechargeAndGainBatteries(
				{ playerId: winnerId },
				gameState
			);
		}

		return winnerId;
	}

	bestManagement(
		playerData: any,
		gameState: GameState,
		prize: boolean = false
	) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		let highestIds: number[] = [];
		let highestPR = 0;
		let numBatteries = 0;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const currPR = players[currId].prArr.length;
			if (currPR > highestPR) {
				highestPR = currPR;
				highestIds = [currId];
				numBatteries = players[currId].batteries;
			} else if (currPR === highestPR) highestIds.push(currId);
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, highestIds);

		if (prize) {
			return this.resolveAwardDonation(highestIds, players, numBatteries);
		}

		return winnerId;
	}

	blackFriday(playerData: any, gameState: GameState, prize: boolean = false) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		let leastIds: number[] = [];
		let mostBatteries = 0;
		let leastBatteries = Infinity;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const currBatteries = players[currId].batteries;
			if (currBatteries < leastBatteries) {
				leastBatteries = currBatteries;
				leastIds = [currId];
			} else if (currBatteries === leastBatteries) leastIds.push(currId);

			if (currBatteries > mostBatteries) {
				mostBatteries = currBatteries;
			}
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, leastIds);

		if (prize) {
			return this.resolveAwardDonation(leastIds, players, mostBatteries);
		}

		return winnerId;
	}

	costmetics(playerData: any, gameState: GameState, prize: boolean = false) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		let highestIds: number[] = [];
		let highestPR = 0;
		let lowestPR = Infinity;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const currPR = players[currId].prArr.length;
			if (currPR > highestPR) {
				highestPR = currPR;
				highestIds = [currId];
			} else if (currPR === highestPR) highestIds.push(currId);

			if (currPR < lowestPR) {
				lowestPR = currPR;
			}
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, highestIds);

		if (prize) {
			return this.resolveAwardDonation(
				highestIds,
				players,
				highestPR - lowestPR
			);
		}

		return winnerId;
	}

	dasExhausting(
		playerData: any,
		gameState: GameState,
		prize: boolean = false
	) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		// currPlayer, create a neighbor array with id of left and right players
		// create an array of all players with lowest CF. if length > 1
		let lowestIds: any = [];
		let lowestCF = Infinity;
		let highestCF = 0;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const currCF = players[currId].carbonFootprint;
			if (currCF < lowestCF) {
				lowestCF = currCF;
				lowestIds = [currId];
			} else if (currCF === lowestCF) lowestIds.push(currId);

			if (currCF >= highestCF) {
				highestCF = currCF;
			}
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, lowestIds);

		if (prize) {
			return this.resolveAwardDonation(
				lowestIds,
				players,
				highestCF - lowestCF
			);
		}

		return winnerId;
	}

	distributeOrSteal(playerData: any, gameState: GameState) {
		const distribute: boolean = playerData?.distribute || null;
		if (distribute) {
			return this.giveNeighborsCFperB(playerData, gameState);
		} else {
			return this.stealBattery(playerData, gameState);
		}
	}

	eCigs(playerData: any, gameState: GameState, prize: boolean = false) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		let highestIds: number[] = [];
		let highestPR = 0;
		let numBatteries = 0;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const currPR = players[currId].prArr.length;
			if (currPR > highestPR) {
				highestPR = currPR;
				highestIds = [currId];
				numBatteries = players[currId].batteries;
			} else if (currPR === highestPR) highestIds.push(currId);
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, highestIds);

		if (prize) {
			return this.resolveAwardDonation(highestIds, players, numBatteries);
		}

		return winnerId;
	}

	// most charged batteries
	electricFence(
		playerData: any,
		gameState: GameState,
		prize: boolean = false
	) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		let highestIds: number[] = [];
		let highestChargedBatteries = 0;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const currChargedBatteries =
				players[currId].batteryEnergyArr.length;
			if (currChargedBatteries > highestChargedBatteries) {
				highestChargedBatteries = currChargedBatteries;
				highestIds = [currId];
			} else if (currChargedBatteries === highestChargedBatteries)
				highestIds.push(currId);
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, highestIds);

		if (prize) {
			return this.resolveAwardDonation(
				highestIds,
				players,
				highestChargedBatteries
			);
		}

		return winnerId;
	}

	entrepreneur(playerData: any, gameState: GameState) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		let mostIds: number[] = [];
		let mostIncompleteCompleteContracts = 0;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const currAC = players[currId].activeContractsAndAwards;
			let currACLength = 0;

			for (let j = 0; j < currAC.length; j++) {
				const currCard = controller_card.getCurrCard(currAC[j]) as any;
				if (currCard.type === 'Contract') {
					currACLength++;
				}
			}

			if (currACLength > mostIncompleteCompleteContracts) {
				mostIncompleteCompleteContracts = currACLength;
				mostIds = [currId];
			} else if (currACLength === mostIncompleteCompleteContracts)
				mostIds.push(currId);
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, mostIds);

		return winnerId;
	}

	foamFinger(playerData: any, gameState: GameState, prize: boolean = false) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		let largestIds: any = [];
		let largestHandSize = 0;
		let smallestHandSize = Infinity;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const currHandSize = players[currId].seasonalCards.length;

			if (currHandSize > largestHandSize) {
				largestHandSize = currHandSize;
				largestIds = [currId];
			} else if (currHandSize === largestHandSize)
				largestIds.push(currId);

			if (currHandSize < smallestHandSize) {
				smallestHandSize = currHandSize;
			}
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, largestIds);

		if (prize) {
			return this.resolveAwardDonation(
				largestIds,
				players,
				largestHandSize - smallestHandSize
			);
		}

		return winnerId;
	}

	giveNeighborsCF(playerData: any, gameState: GameState) {
		const { playerId, targetId } = playerData;

		console.log('giveNeighborsCF');
		console.log(playerId);
		console.log(targetId);

		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		console.log(pState);
		console.log(tState);

		let totalCarbon = 0;
		totalCarbon = Math.min(pState.carbonFootprint, 5); // ensures doesn't exceed battery amount

		pState.carbonFootprint -= totalCarbon;
		tState.carbonFootprint += totalCarbon;

		return true;
	}

	stealSummitCard(playerData: any, gameState: GameState) {
		const { playerId, targetId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		if (tState.summitCards.length <= 0) {
			return true;
		}

		const stolenCardIndex = getRandomArrayIndex(tState.summitCards);

		// useful if you ever implement a discard pile
		const [stolenCard] = tState.summitCards.splice(stolenCardIndex, 1);

		pState.summitCards.push(stolenCard);

		return true;
	}

	giveNeighborsCFperB(playerData: any, gameState: GameState) {
		const { playerId, targetId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		let totalCarbon = 0;
		totalCarbon = Math.min(pState.carbonFootprint, pState.batteries); // ensures doesn't exceed battery amount

		pState.carbonFootprint -= totalCarbon;
		tState.carbonFootprint += totalCarbon;

		return true;
	}

	gov1(playerData: any, gameState: GameState, prize: boolean = false) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		let mostIds: number[] = [];
		let mostCompleteContracts = 0;
		let leastCompleteContracts = Infinity;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const currCC = players[currId].completedContracts.length;
			if (currCC > mostCompleteContracts) {
				mostCompleteContracts = currCC;
				mostIds = [currId];
			} else if (currCC === mostCompleteContracts) mostIds.push(currId);

			if (currCC < leastCompleteContracts) {
				leastCompleteContracts = currCC;
			}
		}

		let totalFailedCC = 0;

		if (mostIds.length !== 1) return false;

		for (let j = 0; j < neighborArr.length; j++) {
			const currId = neighborArr[j];
			if (currId === mostIds[0]) continue;

			totalFailedCC += players[currId].failedContracts.length;
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, mostIds);

		if (prize) {
			return this.resolveAwardDonation(mostIds, players, totalFailedCC);
		}

		return winnerId;
	}

	gov2(playerData: any, gameState: GameState, prize: boolean = false) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		let mostIds: number[] = [];
		let mostFailedContracts = 0;
		let leastFailedContracts = Infinity;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const currCC = players[currId].completedContracts.length;
			if (currCC > mostFailedContracts) {
				mostFailedContracts = currCC;
				mostIds = [currId];
			} else if (currCC === mostFailedContracts) mostIds.push(currId);

			if (currCC < leastFailedContracts) {
				leastFailedContracts = currCC;
			}
		}

		let totalFailedCC = 0;

		if (mostIds.length !== 1) return -1;

		for (let j = 0; j < neighborArr.length; j++) {
			const currId = neighborArr[j];
			if (currId === mostIds[0]) continue;

			totalFailedCC += players[currId].failedContracts.length;
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, mostIds);

		if (prize) {
			return this.resolveAwardDonation(mostIds, players, totalFailedCC);
		}

		return winnerId;
	}

	keepingCurrent(
		playerData: any,
		gameState: GameState,
		prize: boolean = false
	) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		let highestIds: number[] = [];
		let highestBatteries = 0;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const currBatteries = players[currId].batteries;
			if (currBatteries > highestBatteries) {
				highestBatteries = currBatteries;
				highestIds = [currId];
			} else if (currBatteries === highestBatteries)
				highestIds.push(currId);
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, highestIds);

		if (prize) {
			return this.resolveAwardDonation(
				highestIds,
				players,
				highestBatteries
			);
		}

		return winnerId;
	}

	highestCarbonFootprint(playerData: any, gameState: GameState) {
		const playerNeighborTestArr = act_com.createNeighborIdArray(
			playerData,
			gameState.playerStateArray
		);

		let highestCF = 0;
		let highestCFIds: number[] = [];
		for (let i = 0; i < playerNeighborTestArr.length; i++) {
			const p = gameState.playerStateArray[playerNeighborTestArr[i]];
			if (p.carbonFootprint > highestCF) {
				highestCF = p.carbonFootprint;
				highestCFIds = [playerNeighborTestArr[i]];
			} else if (p.carbonFootprint === highestCF) {
				highestCFIds.push(playerNeighborTestArr[i]);
			}
		}

		if (highestCFIds.length === 1) {
			return highestCFIds[0];
		}

		return -1;
	}

	industrialist(
		playerData: any,
		gameState: GameState,
		prize: boolean = false
	) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		let mostIds: number[] = [];
		let mostFactories = 0;
		let leastFactories = Infinity;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const currFactories = players[currId].factories;
			if (currFactories > mostFactories) {
				mostFactories = currFactories;
				mostIds = [currId];
			} else if (currFactories === mostFactories) mostIds.push(currId);

			if (currFactories < leastFactories) {
				leastFactories = currFactories;
			}
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, mostIds);

		if (prize) {
			return this.resolveAwardDonation(
				mostIds,
				players,
				mostFactories - leastFactories
			);
		}

		return winnerId;
	}

	lowestPR(playerData: any, gameState: GameState, prize: boolean = false) {
		const playerNeighborTestArr = act_com.createNeighborIdArray(
			playerData,
			gameState.playerStateArray
		);

		const players = gameState.playerStateArray;
		let lowestPR = Infinity;
		let lowestPRIds: number[] = [];
		for (let i = 0; i < playerNeighborTestArr.length; i++) {
			const p = gameState.playerStateArray[playerNeighborTestArr[i]];
			if (lowestPR > p.prArr.length) {
				lowestPR = p.prArr.length;
				lowestPRIds = [playerNeighborTestArr[i]];
			} else if (lowestPR === p.prArr.length) {
				lowestPRIds.push(playerNeighborTestArr[i]);
			}
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, lowestPRIds);

		if (prize) {
			return act_com.rechargeAllBatteries(
				{ playerId: winnerId },
				gameState
			);
		}

		return winnerId;
	}

	nepotism(playerData: any, gameState: GameState, prize: boolean = false) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		let leastIds: number[] = [];
		let mostFactories = 0;
		let leastFactories = Infinity;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const currFactories = players[currId].factories;
			if (currFactories < leastFactories) {
				leastFactories = currFactories;
				leastIds = [currId];
			} else if (currFactories === leastFactories) leastIds.push(currId);

			if (currFactories >= mostFactories) {
				mostFactories = currFactories;
			}
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, leastIds);

		if (prize) {
			return this.resolveAwardDonation(leastIds, players, mostFactories);
		}

		return winnerId;
	}

	donateAmountForAllPlayerIds(
		samePrIds: number[],
		players: any,
		amount: number
	) {
		if (samePrIds.length > 1) {
			for (let i = 0; i < samePrIds.length; i++) {
				this.resolveAwardDonation(samePrIds[i], players, amount);
			}

			return true;
		}
	}

	noEnergyLeftBehind(
		playerData: any,
		gameState: GameState,
		prize: boolean = false
	) {
		const playerId = playerData.playerId;
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);
		let currPr = players[playerId].prArr.length;
		const leftId = neighborArr[0];
		const rightId = neighborArr[2];
		let samePrIds = [playerId];

		console.log('noEnergyLeftBehind');
		console.log('currPr: ' + currPr);
		console.log('playerId: ' + playerId);
		console.log('leftId: ' + leftId);
		console.log('rightId: ' + rightId);

		if (players[leftId].prArr.length === currPr) {
			samePrIds.push(leftId);
		}

		if (players[rightId].prArr.length === currPr) {
			samePrIds.push(rightId);
		}

		if (samePrIds.length > 1 && currPr > 0) {
			console.log('match with player who played card');
			if (prize) {
				this.donateAmountForAllPlayerIds(samePrIds, players, currPr);
			}
			return playerId;
		}

		currPr = players[leftId].prArr.length;

		if (currPr === players[rightId].prArr.length && currPr > 0) {
			console.log('match without player who played card');
			samePrIds = [leftId, rightId];

			if (prize) {
				this.donateAmountForAllPlayerIds(samePrIds, players, currPr);
			}

			const randomId = Math.random() < 0.5 ? 0 : 1;
			const selectedPlayerId = samePrIds[randomId];
			console.log(`Player ${selectedPlayerId} randomly selected`);

			return selectedPlayerId;
		}

		return -1;
	}

	participationTrophy(
		playerData: any,
		gameState: GameState,
		prize: boolean = false
	) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		let highestIds: number[] = [];
		let highestPR = 0;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const currPR = players[currId].prArr.length;
			if (currPR > highestPR) {
				highestPR = currPR;
				highestIds = [currId];
			} else if (currPR === highestPR) highestIds.push(currId);
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, highestIds);

		if (prize) {
			return act_com.rechargeAllBatteries(
				{ playerId: winnerId },
				gameState
			);
		}

		return winnerId;
	}

	puppyBowl(playerData: any, gameState: GameState, prize: boolean = false) {
		const playerNeighborTestArr = act_com.createNeighborIdArray(
			playerData,
			gameState.playerStateArray
		);

		const players = gameState.playerStateArray;

		let highestCF = 0;
		let highestCFIds: any = [];
		for (let i = 0; i < playerNeighborTestArr.length; i++) {
			const p = gameState.playerStateArray[playerNeighborTestArr[i]];
			if (p.carbonFootprint > highestCF) {
				highestCF = p.carbonFootprint;
				highestCFIds = [playerNeighborTestArr[i]];
			} else if (p.carbonFootprint === highestCF) {
				highestCFIds.push(playerNeighborTestArr[i]);
			}
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, highestCFIds);

		if (prize) {
			return this.giveNeighborsCFperB({ playerId: winnerId }, gameState);
		}

		return winnerId;
	}

	rAndD(playerData: any, gameState: GameState, prize: boolean = false) {
		const players = gameState.playerStateArray;
		const neighborArr = act_com.createNeighborIdArray(playerData, players);

		let highestIds: number[] = [];
		let highestNumEquipment = 0;

		for (let i = 0; i < neighborArr.length; i++) {
			const currId = neighborArr[i];
			const numEquipment = players[currId].equipment.length;
			if (numEquipment > highestNumEquipment) {
				highestNumEquipment = numEquipment;
				highestIds = [currId];
			} else if (numEquipment === highestNumEquipment)
				highestIds.push(currId);
		}

		const winnerId = this.getWinnerIdFromArrayIndex(players, highestIds);

		if (prize) {
			return this.resolveAwardDonation(
				highestIds,
				players,
				players[playerData.playerId].equipment.length * 2
			);
		}

		return winnerId;
	}

	setTargetArrToNeighbors(playerData: any, gameState: GameState) {
		// decisionChoiceArr,
		// decisionSourceArr,
		// decisionTargetArr,
		const neighborArr = act_com.createAwardTargetArrayVerbose(
			playerData,
			gameState.playerStateArray
		);

		gameState.decisionTargetArr = neighborArr;
	}

	stealBattery(playerData: any, gameState: GameState) {
		const { playerId, targetId } = playerData;
		console.log('stealBattery');
		console.log('playerId: ' + playerId);
		console.log('targetId: ' + targetId);
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		console.log('pState: ' + pState);
		console.log('tState: ' + tState);

		console.log('tState.batteries: ' + tState.batteries);
		console.log('pState.batteries: ' + pState.batteries);

		if (tState.batteries > 0 && pState.batteries < 6) {
			tState.batteries--;
			act_player.buyBattery(pState);
			if (tState.batteryEnergyArr.length > tState.batteries) {
				const be = tState.batteryEnergyArr.pop();
				act_player.refillBattery(pState, be);
			}
			return true;
		}
		return -1;
	}
}

export const act_awd = new AwardAction();
